import React, { ComponentProps, PropsWithChildren } from 'react';

import { LegacyButton, Spinner } from '@zapier/design-system';

type Props = ComponentProps<typeof LegacyButton> & {
  /** Flag to render the Spinner icon */
  isWorking: boolean;
};

const AsyncButton = ({
  children,
  isWorking,
  ...buttonProps
}: PropsWithChildren<Props>) => {
  const content = isWorking ? (
    <Spinner aria-label="Content is loading" />
  ) : (
    children
  );

  return <LegacyButton {...buttonProps}>{content}</LegacyButton>;
};

export default AsyncButton;
